import React from "react";

const RichText = (props) => {
  // Split by newline
  const lines = props.children.split('\n');

  return (
    <div {...props}>
      {lines.map((line, index) => (
        <p key={index}>
          {parseBoldTags(line)}
        </p>
      ))}
    </div>
  );
};

// Helper function to convert <b>...</b> to <strong>
const parseBoldTags = (line) => {
  const parts = line.split(/(<b>.*?<\/b>)/g); // Keep the <b> tags

  return parts.map((part, i) => {
    if (part.startsWith('<b>') && part.endsWith('</b>')) {
      const content = part.slice(3, -4);
      return <strong key={i}>{content}</strong>;
    } else {
      return <React.Fragment key={i}>{part}</React.Fragment>;
    }
  });
};

export default RichText;
